import { createAction, props } from '@ngrx/store';

export const showSnackbar = createAction(
    '[Application Effects] Show Snackbar',
    props<{ iconName: string; text: string; iconColor?: string }>()
);
